import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "iMJka8",
    defaultMessage: "No pages found",
  },
  published: {
    id: "G1KzEx",
    defaultMessage: "Published",
    description: "page status",
  },
  notPublished: {
    id: "WvMDHa",
    defaultMessage: "Not published",
    description: "page status",
  },
});

export const columnsMessages = defineMessages({
  title: {
    id: "0XHXTZ",
    defaultMessage: "Title",
    description: "column header",
  },
  slug: {
    id: "kIcyUo",
    defaultMessage: "Slug",
    description: "column header",
  },
  visible: {
    id: "wLB8B3",
    defaultMessage: "Visibility",
    description: "column header",
  },
});
